$(function () {
  $(document).on("click.yiiGridView", ".filters td", (event) => {
    if (
      event.target &&
      event.target.name &&
      event.target.name.includes("ProjectsTasks")
    ) {
      const paramName = event.target.name
        .replace("ProjectsTasks[", "")
        .replace("]", "");
      const userIdEl = document.getElementById("userId");
      const userId = userIdEl ? userIdEl.content : "0";
      try {
        window.dataLayer.push({
          event: "tasks_fields",
          fields_name: paramName,
          user_id: userId,
        });
      } catch (_) {}
    }
  });

  $(document).on("change.yiiGridView", "#ProjectsTasks_status", (event) => {
    let text = "";
    switch (event.target.value) {
      case "1":
        text = "New";
        break;
      case "2":
        text = "In progress";
        break;
      case "3":
        text = "Reviewing by customer";
        break;
      case "4":
        text = "Pending payment";
        break;
      case "5":
        text = "Paid";
        break;
      case "6":
        text = "Cancel confirmation";
        break;
      case "8":
        text = "Declined by customer";
        break;
      case "11":
        text = "Declined by contractor";
        break;
      case "12":
        text = "Payment is queued";
        break;
      case "13":
        text = "Dispute in progress";
        break;
      case "14":
        text = "Customer approval";
        break;
      case "15":
        text = "Declined by customer";
        break;
      case "16":
        text = "Changes approval";
        break;
      case "17":
        text = "Drafts";
        break;
      default:
        text = event.target.value.includes(5)
          ? "All tasks"
          : "All tasks except completed";
        break;
    }
    const userIdEl = document.getElementById("userId");
    const taskFilterElement = document.querySelector("element-task-filter");
    taskFilterElement.activeFilter = text;

    const userId = userIdEl ? userIdEl.content : "0";
    try {
      window.dataLayer.push({
        event: "tasks_status_dropdown",
        status_name: text,
        user_id: userId,
      });
    } catch (_) {}
  });

  $(document).on("click.yiiGridView", ".sort-link", (event) => {
    if (event.target && event.target.href) {
      const sortParam = event.target.href
        .split("&")
        .find((el) => el.includes("ProjectsTasks_sort"));
      if (sortParam) {
        const columnName = sortParam.split("=").pop();
        const userIdEl = document.getElementById("userId");
        const userId = userIdEl ? userIdEl.content : "0";
        try {
          window.dataLayer.push({
            event: "tasks_sort_by",
            column: columnName,
            user_id: userId,
          });
        } catch (_) {}
      }
    }
  });
});
